module.exports = JSON.parse
